module.exports = __webpack_public_path__ + "static/img/griffin.9f69947.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cards/monster/griffin.png
// module id = 3ute
// module chunks = 0